import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { fontFamilySans } from "@styles/type.styles";
import { greys } from "@styles/color.styles";

export const hourText: CSSProperties = {
  position: "absolute",
  fontFamily: fontFamilySans,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "10px",
  lineHeight: "12px",
  color: greys.blueGrey,
};

const container: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  position: "relative",
  flex: 1,
  userSelect: "none",
  "& > .hours": {
    display: "flex",
    background: "transparent",
    position: "relative",
    marginTop: 40,
    height: "calc(100% - 40px)",
    width: 20,
    "&:after": {
      content: '""',
      borderRight: `1px solid ${greys.borderGrey}`,
      top: -20,
      bottom: -20,
      position: "absolute",
      zIndex: 8,
      right: 0,
    },
  },

  "& > .hours-no-labels": {
    display: "flex",
    background: "transparent",
    position: "relative",
    marginTop: 40,
    height: "calc(100% - 40px)",
    width: 20,
    "&:after": {
      content: '""',
      borderRight: `1px solid ${greys.borderGrey}`,
      top: 0,
      bottom: 0,
      position: "absolute",
      zIndex: 8,
      right: 0,
    },
  },

  "& > .relative-view-wrapper": {
    width: "100%",
    height: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",

    "&.empty": {
      flex: 0.5,
    },

    "& > .day-name": {
      height: 40,
      textAlign: "center",
      fontFamily: fontFamilySans,
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "12.8672px",
      lineHeight: "12px",
      color: greys.blueGrey,
    },

    "& > .relative-view": {
      background: "#fff",
      borderBottom: `1px solid ${greys.borderGrey}`,
      flex: 1,
      "&:after": {
        content: '""',
        borderRight: `1px solid ${greys.borderGrey}`,
        top: -20,
        bottom: -20,
        position: "absolute",
        zIndex: 8,
        right: 0,
      },
    },
    "& > .relative-view-no-labels": {
      background: "#fff",
      borderBottom: `1px solid ${greys.borderGrey}`,
      flex: 1,
      "&:after": {
        content: '""',
        borderRight: `1px solid ${greys.borderGrey}`,
        top: 0,
        bottom: 0,
        position: "absolute",
        zIndex: 8,
        right: 0,
      },
    },
  },

  "&:last-child": {
    borderRight: "none",
  },
};

const horizontalGridContainer: CSSProperties = {
  position: "absolute",
  width: "100%",
  height: "100%",
  paddingTop: 40,

  "& > .relative-view": {
    position: "relative",
    width: "100%",
    height: "100%",

    "& > .horizontal-grid": {
      position: "absolute",
      borderBottom: `1px solid ${greys.borderGrey}`,
      right: -20,
      left: 0,
      zIndex: 8,
    },

    "& > .horizontal-grid-no-labels": {
      position: "absolute",
      borderBottom: `1px solid ${greys.borderGrey}`,
      right: 0,
      left: 0,
      zIndex: 8,
    },
  },
};

export const styles = {
  container,
  horizontalGridContainer,
};
